import { Button, Collapse, Box, Container } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';

type Props = {
  title?: string;
  children?: React.ReactNode;
};

export const CustomCollapse = (props: Props) => {
  const {
    title = 'Фильтр',
    children,
  } = props;
  const [opened, { toggle }] = useDisclosure(false);

  return (
    <Box w="100%" mb={15} style={{ border: '1px solid #cccccc', borderRadius: '5px' }}>
      <Button
        onClick={toggle}
        variant='default'
        fullWidth
        justify='left'
        style={{ border: 'none', borderBottom: '1px solid #cccccc', borderRadius: '5px' }}
        leftSection={
          <IconChevronRight
            size={16}
            stroke={1.5}
            style={{
              transform: opened ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 200ms ease',
            }}
          />}
      >
        {title}
      </Button>

      <Collapse in={opened}>
        <Container mt={10} mb={10} size="lg">
          {children}
        </Container>
      </Collapse>
    </Box>
  );
};
